export default __webpack_public_path__ + "static/media/dieppe4.9744d480.jpg";